import AdminLayout from '@/layouts/AdminLayout.vue'

export default [
  {
    path: '/email-outbox',
    name: 'emailOutbox',
    component: () => import('@/views/restricted/email-outbox/EmailOutboxLayoutView.vue'),
    meta: {
      requiresAuth: true,
      layout: AdminLayout,
      permissions: ['ADMIN_EMAIL_OUTBOX_READ'],
      menuSelected: 'email-outbox'
    }
  }
]
